<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <Mlogin />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">电子版订阅</div>
                  <div class="title_more2"><a href="">首页</a>>电子版订阅</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="srr_con xbjj_con">
                    <p>
                      说明：1)
                      如果您只想订阅我们杂志的电子版，输入Email后点击订阅即可。2)
                      如果您想订阅印刷版杂志点击<a href="#" class="highblue"
                        >订阅办法</a
                      >。3) 如果您还要投稿，请点击<a href="#" class="highblue"
                        >作者注册</a
                      >按钮。
                    </p>
                    <div class="part">
                      订阅电子版
                      <div>
                        订阅Email：<input
                          name="ctl00$cphContect$TBEmailBox"
                          text
                          id="ctl00_cphContect_TBEmailBox"
                          class="text"
                          value="请输入邮箱地址"
                        />
                        <span
                          id="ctl00_cphContect_Regularexpressionvalidator1"
                          style="visibility: hidden"
                          >您的信箱错误！</span
                        >
                        <input
                          type="submit"
                          name="ctl00$cphContect$Button1"
                          value="订  阅"
                          onclick='javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions("ctl00$cphContect$Button1", "", true, "", "", false, false))'
                          id="ctl00_cphContect_Button1"
                          class="button"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
    }
  },
  components: {},
  methods: {},
}
</script>

<style scoped></style>
